<template>
  <div class="main-category-page page">
    <ServicesHeader
      :title="data | localeField('name')"
      :breadcrumbs="breadcrumbs"
    />
    <div class="main-category-page__inner page__inner container">
      <MainCategoryComponent :data="data" full-width />
      <EventPopularServices
        class="main-category-page__popular-services"
        :event-id="eventId"
        full-width
      />
    </div>
  </div>
</template>

<script>
import ServicesHeader from "@/components/Custom/ServicesHeader.vue";
import MainCategoryComponent from "@/components/Custom/MainCategoryComponent.vue";
import EventPopularServices from "@/components/Custom/EventPopularServices.vue";
import { mapGetters } from "vuex";

export default {
  name: "MainCategoryPage",
  components: {
    EventPopularServices,
    ServicesHeader,
    MainCategoryComponent
  },
  props: {
    data: Object
  },
  computed: {
    ...mapGetters("event", ["eventId"]),
    breadcrumbs() {
      return [
        {
          title_rus: "Выставка",
          title_eng: "Exhibition",
          route: { name: "participant", params: { id: this.$route.params.id } }
        },
        {
          title_rus: "Заказ услуг",
          title_eng: "Services ordering",
          route: { name: "categories", params: { id: this.$route.params.id } }
        }
      ];
    }
  }
};
</script>

<style lang="scss">
.main-category {
  margin-top: 25px;
}
.main-category-page {
  &__popular-services {
    margin-top: 50px;
    @media (max-width: 540px) {
      margin-top: 30px;
    }
  }
}
</style>
